import React, { Fragment } from 'react';
var CollapsibleFooter = function (props) {
    return React.createElement(Fragment, null, props.children);
};
export default CollapsibleFooter;
